import React, { Component } from "react";
import PropTypes from "prop-types";
import { childrenPropType } from "components/propTypes";
import TooltipInline from "components/source/shared/tooltip-inline";

// ToolTipIcon can manage their state on their own or allow for parent
// components to do so. this is useful when you have more than one tooltip on
// a page and want to be sure only one is showing at a time
export class ToolTipIconComponent extends Component {
  static propTypes = {
    align: PropTypes.oneOf(["left", "center", "right"]),
    children: childrenPropType.isRequired,
    iconClassName: PropTypes.string,
    isVisible: PropTypes.bool, // required if onToggleVisibility is used
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onToggleVisibility: PropTypes.func,
    position: PropTypes.string,
    Icon: PropTypes.any,
    toolTipClassName: PropTypes.string,
  };

  static defaultProps = {
    iconClassName: "reb-tooltip",
    position: "bottom",
    toolTipClassName: "tool-tip-icon",
  };

  state = {
    isVisible: false,
  };

  getIsVisible() {
    const { isVisible = this.state.isVisible } = this.props;

    return isVisible;
  }

  toggleVisibility = (event, isVisible = !this.getIsVisible()) => {
    const { onToggleVisibility } = this.props;

    // with tool tips & modals, I expect there will be a container#onClick to
    // hide the tooltip. stop propagation/prevent default to allows for that.
    // it would probably be better to pass this to onToggleVisibility, but...
    if (event) {
      event.preventDefault();
    }

    // no parent visibility control? no problem, handle it internally
    if (!onToggleVisibility) {
      return this.setState({ isVisible });
    }

    onToggleVisibility(isVisible);
  };

  renderToolTip(children) {
    const { align } = this.props;

    if (!children) {
      return null;
    }

    return (
      <TooltipInline
        align={align}
        position={this.props.position}
        display={this.getIsVisible()}
        onToggleTooltip={(...args) => this.toggleVisibility(null, ...args)}>
        <div className="tool-tip-content">{children}</div>
      </TooltipInline>
    );
  }

  renderIcon() {
    const { Icon, iconClassName } = this.props;
    if (Icon) {
      return <Icon />;
    }
    return <div className={`icon ${iconClassName}`} />;
  }

  render() {
    const { children, label } = this.props;
    const toolTipContent = this.renderToolTip(children);

    // onMouseOver works for clicks on mobile as well
    const eventHandlers = {
      onMouseOver: e => this.toggleVisibility(e, true),
      onMouseOut: e => this.toggleVisibility(e, false),
    };

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <div className={this.props.toolTipClassName} data-test-id="tool-tip-icon" {...eventHandlers}>
        {label}
        {this.renderIcon()}
        {toolTipContent}
      </div>
    );
  }
}

const ToolTipIcon = ToolTipIconComponent;

export default ToolTipIcon;
